// Register the Stowlane service worker so the app is installable and works as
// a PWA. The worker is served from the site root (/service-worker) so its scope
// is the whole site. Registration is best-effort: unsupported browsers and any
// registration error are silently ignored — the app still works without it.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker").catch(() => {
      // Ignore — a failed SW registration must never break the page.
    })
  })
}

// Tell the server whether this page is running as an INSTALLED app, because no
// browser sends a request header for display mode. BrandedHostSessionTtl reads
// this to give the installed portal a 36-hour window instead of 12 — see that
// file for why a client-asserted flag is safe for this and nothing else.
//
// Both checks are needed: `display-mode: standalone` is the standard, and
// `navigator.standalone` is Safari's iOS-only predecessor — which is the case
// that matters most here, since iOS never fires beforeinstallprompt and is where
// a home-screen app is most likely to be evicted and need to sign in again.
//
// Re-evaluated on every load and CLEARED when not standalone, so a browser tab
// in a profile that also has the app installed can't inherit the longer window.
const STANDALONE_MARKER = "stowlane_pwa"

function recordDisplayMode() {
  const standalone =
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true

  const secure = window.location.protocol === "https:" ? "; secure" : ""
  document.cookie = standalone
    ? `${STANDALONE_MARKER}=1; path=/; max-age=31536000; samesite=lax${secure}`
    : `${STANDALONE_MARKER}=; path=/; max-age=0; samesite=lax${secure}`
}

try {
  recordDisplayMode()
} catch (error) {
  // A browser without matchMedia just stays on the default window.
}
